import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  chip: {
    backgroundColor: '#e62954',
    color: '#f8f9fa',
    margin: '1px',
  },
  chipBrand: {
    backgroundColor: '#78001b',
    color: '#f8f9fa',
    margin: '1px',
  },
  chipProduct: {
    backgroundColor: '#bf002b',
    color: '#f8f9fa',
    margin: '1px',
  },
}));
